// The default AI agent's name in onboarding and setup copy
export const AI_NAME = 'Lightdash';
